// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2RaRV","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3zjJG"};